/**
 * Recipes block category filter.
 * Handles show/hide based on category.
 */
export default function initRecipesFilter() {
  const filterButtons = document.querySelectorAll('.recipes-filter button');

  if (!filterButtons.length) {
    return;
  }

  filterButtons.forEach( ( button ) => {
    button.addEventListener( 'click', () => {
      const filter = button.dataset.filter;

      filterButtons.forEach( ( btn ) => {
        btn.classList.remove( 'is-active' );
        btn.setAttribute( 'aria-pressed', 'false' );
      } );
      button.classList.add( 'is-active' );
      button.setAttribute( 'aria-pressed', 'true' );

      const recipes = document.querySelectorAll( '.block-recipes .recipe' );
      recipes.forEach( ( recipe ) => {
        if ( filter === 'all' || recipe.classList.contains( 'is-cat-' + filter ) ) {
          recipe.hidden = false;
        } else {
          recipe.hidden = true;
        }
      } );

      const recipesBlock = button.closest( '.block-recipes' );
      if ( recipesBlock ) {
        recipesBlock.scrollIntoView( { behavior: 'smooth', block: 'start' } );
      }
    } );
  } );
}
